var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2StormNight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.6 27.89a15.2 15.2 0 01-11.52 7.69 15.54 15.54 0 00-10.16-5.26 19.52 19.52 0 00-7-9.76A15.28 15.28 0 0156.64 5.27c-3.12 4.31-2.75 11.09 1.3 16.49 3.84 5.12 9.79 7.42 14.66 6.13zm-22.95 7h-1.78a15.3 15.3 0 00-4.68-9 15.56 15.56 0 00-26 9h-1.84a11.5 11.5 0 100 23H23v-3.8h-7.65a7.68 7.68 0 01-7.67-7.67A7.48 7.48 0 0115.35 39h5.41v-2.09a11.69 11.69 0 1123.38 0V39h5.41a7.48 7.48 0 017.67 7.44 7.68 7.68 0 01-7.67 7.67H46v3.83h3.65a11.5 11.5 0 100-23v-.05zM34.38 42l-7.9 15.89h5.81l-5.52 14 16-17.79h-9.1L43.29 42h-8.91z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B2_Storm_night.fe7a0675.svg";
export { SvgB2StormNight as ReactComponent };